export default "__VITE_ASSET__67de5430__"